export default __webpack_public_path__ + "static/media/cv_200kb.ce4e9f3c.jpg";